<template>
  <div class="step-wrapper">
      <verification v-show="wizardStep === 'verification'" :default-values="values"
        :on-input-change="onVerificationInputChange" :is-redirect-voucher="true" />
      <div v-show="wizardStep === 'redirect'">
        {{ $t('discount.voucher.redirect.info') }}
        <loading-symbol />
      </div>
      <verification-error v-show="wizardStep === 'verificationError'" />
      <card-type-error v-show="wizardStep === 'cardTypeError'" />
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import Verification from './steps/Verification.vue';
import VerificationError from './steps/VerificationError.vue';
import CardTypeError from './steps/CardTypeError.vue';
import LoadingSymbol from '../LoadingSymbol.vue';

export default {
  name: 'redirect-voucher-wizard',
  props: {
    redirectUrl: {
      type: String,
      required: true,
    },
  },
  created() {
    this.setVoucherWizardStep('verification');
  },
  computed: {
    ...mapState({
      wizardStep: (state) => state.voucher.currentStep,
      loading: (state) => state.voucher.loading,
      verification: (state) => state.voucher.verification,
      benefitLink: (state) => state.benefit.benefitLink,
    }),
  },
  methods: {
    ...mapActions({
      setVoucherWizardStep: 'setVoucherWizardStep',
      closeRedirectDialog: 'closeRedirectDialog',
      removeRouteParam: 'removeRouteParam',
    }),
    onVerificationInputChange(key, value) {
      this.values[key] = value;
    },
  },
  watch: {
    benefitLink(link) {
      if (link === undefined) {
        return;
      }
      window.top.location.href = link !== null ? link : this.redirectUrl;
      this.closeRedirectDialog();
      this.removeRouteParam('redirectOffer');
    },
  },
  data() {
    return {
      values: {
        isicNumber: null,
        cardholderName: null,
      },
      validationErrors: {},
      verificationError: null,
    };
  },
  components: {
    Verification,
    VerificationError,
    CardTypeError,
    LoadingSymbol,
  },
};
</script>
